module.exports = __webpack_public_path__ + "img/icon-3.5e4f1739.png";